import { render, staticRenderFns } from "./oaff.vue?vue&type=template&id=1c1a7d70&scoped=true"
import script from "./oaff.vue?vue&type=script&lang=js"
export * from "./oaff.vue?vue&type=script&lang=js"
import style0 from "./oaff.vue?vue&type=style&index=0&id=1c1a7d70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1a7d70",
  null
  
)

export default component.exports